export enum MaintenanceRequestStatus {
  Closed = 'closed',
  Pending = 'pending',
  InProgress = 'inProgress',
  OnHold = 'onHold',
  Cancelled = 'cancelled',
  WorkOrder = 'waitingForWorkOrder',
  Processing = 'aiProcessing',
}

export enum MaintenanceRequestFilterStatus {
  All = 'all',
  Closed = 'closed',
  Pending = 'pending',
  InProgress = 'inProgress',
  WaitingForWorkOrder = 'waitingForWorkOrder',
  AiProcessing = 'aiProcessing',
}
